import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const enforcementDefinition: ResourceDefinition = {
  title: 'Enforcements',
  nameSingular: 'Enforcement',
  namePlural: 'Enforcements',
  className: 'Enforcement',
  mainIdentifier: 'name',
  slug: 'taxonomies/enforcements',
  path: 'enforcements',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (enforcement) => ({
        type: ActionType.Link,
        link: {
          path: `${enforcementDefinition.path}/${enforcement.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (enforcement) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: enforcement,
          definition: enforcementDefinition
        }
      })
    }
  ]
}
